<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="2000px">
      <v-card>
        <v-card-text class="pt-4">
          <v-row v-for="(floor, index) in floors" :key="index">
            <v-col
              v-for="(item, index) in filterFloor(floor)"
              :key="index"
              class="flex-grow-0 pt-0 pb-0 pr-1 pl-1"
            >
              <!-- 2024.10.10 kouta_noborisaka カードの最小表示幅を190に設定 -->
              <v-card
                v-bind:color="
                  floor % 2 == 0 ? 'blue lighten-5' : 'grey lighten-3'
                "
                min-width="190"
              >
                <v-card-text class="text-center pa-0">
                  <v-checkbox
                    v-model="selectUserList"
                    :value="item"
                    :label="item.room_id"
                    hide-details="false"
                    class="mt-1 mb-0 mr-0 ml-0 labelStyle"
                  ></v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ryou-black-btn
            :label="'閉じる'"
            :handlerClick="handleCancel"
            :iconCls="'mdi-close'"
          >
          </ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn
            :label="'設定'"
            :handlerClick="handleOk"
          ></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";

export default {
  components: {
    RyouBlackBtn,
  },
  mounted() {
    this.inputRules.push(this.GlobalRules.required);
  },
  data: () => ({
    dialog: false,
    valid: true,
    inputRules: [],
    items: [],
    floors: [],
    selectUserList: [],
    url: {
      get: "/noticeRegistration/buildGroupTenantGet/",
    },
    props: ["parentBuildGroupId"],
  }),
  methods: {
    selectUsers() {
      this.open();
    },
    handleCancel() {
      this.close();
    },
    handleOk() {
      // グリッドによって選択された結果セットをループさせると、親画面のデータを返します
      var tempId = "";
      var tempName = "";
      this.selectUserList.forEach((item) => {
        tempId += item.user_id + "/";
        tempName += item.user_name + "\r\n";
      });
      var arr = [tempId, tempName];
      this.$emit("setDataByChild", arr);
      this.close();
    },
    close() {
      //this.$refs.ryouTablePop.selected = [];
      this.dialog = false;
    },
    open() {
      this.floors = [];
      this.selectUserList = [];
      this.items = [];
      this.dialog = true;
      this.fetchUserList();
    },
    //ユーザ情報を階で絞り込む
    filterFloor(floor) {
      return this.items.filter((x) => x.floor == floor);
    },
    //DBからユーザリストを取得する
    fetchUserList() {
      this.getRequest(
        this.url.get +
          this.$store.getters.getUserId +
          "/" +
          this.$store.getters.getUserClass,
        null,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success && data.status == "200") {
          // ユーザのリストを作成
          this.items = data.result;

          //ソート
          this.items = this.items.sort((a, b) => {
            if (a.room_id > b.room_id) {
              return 1;
            } else {
              return -1;
            }
          });

          //部屋番号とユーザ名を結合
          var tmp = this.items.map((item) => {
            item.room_id =
              item.room_id == null
                ? item.user_name
                : item.room_id + ":" + item.user_name;
            return item;
          });
          this.items = tmp;

          ////階リスト////
          //階のみ取り出す
          var floors_tmp = this.items
            .map((item) => {
              return [item["floor"]];
            })
            .reduce(function (a, b) {
              return a.concat(b);
            });

          //重複を削除
          this.floors = Array.from(new Set(floors_tmp));

          //ソート
          this.floors = this.floors.sort((a, b) => a - b);
        }
      });
    },
  },
};
</script>

<style scoped>
.labelStyle {
  white-space: nowrap; /* 2024.10.10 kouta_noborisaka ラベルを1行で表示する */
  /* overflow: hidden;
  text-overflow: ellipsis; */
}
</style>
